import ErrorIcon from './internals/Error';
import Info from './internals/Info';
import Warning from './internals/Warning';
import CheckCircle from './internals/CheckCircle';
import Help from './internals/Help';

export default {
  error: ErrorIcon,
  info: Info,
  warning: Warning,
  success: CheckCircle,
  confirm: Help,
};



// WEBPACK FOOTER //
// ./src/icons/statusIcons.jsx